import React from 'react';
import classNames from 'classnames';

import Image from 'components/common/Image';

import { getImageUrl } from 'support/imageHelper';
import equalizerImage from 'assets/images/equalizer.webp';

import styles from './MediaView.module.scss';
import { TileSize } from 'app-types';

const getWidthFromSize = (size: TileSize | null | undefined): number => {
  switch (size) {
    case 'sm':
      return 303;
    case 'md':
      return 390;
    case 'lg':
    default:
      return 478;
  }
};

interface MediaViewProps {
  src?: string | null;
  size?: TileSize | null;
  isNowPlaying?: boolean;
  renderMetadata?: ((hasFocus: boolean) => React.ReactNode) | null;
  autoSizeSrc?: boolean;
  hasFocus?: boolean;
  isHighlights?: boolean;
  className?: string | null;
  isDvr?: boolean;
}

const MediaView = ({
  src: originalSrc = null,
  size = null,
  isNowPlaying = false,
  renderMetadata = null,
  autoSizeSrc = true,
  hasFocus = false,
  isHighlights = false,
  className = null,
  isDvr = false,
}: MediaViewProps) => {
  const src = autoSizeSrc
    ? getImageUrl(originalSrc, getWidthFromSize(size))
    : originalSrc;
  return (
    <div
      className={classNames('w-100', 'position-relative', styles[`${size}_h`])}
      data-testid="media-view"
    >
      <Image
        alt="media view background"
        src={src}
        className={classNames('w-100', 'h-100', styles.image, className)}
        data-testid="background-image"
      />
      <div
        className={classNames(
          'w-100',
          'h-100',
          styles.imageOverlay,
          isDvr ? styles.dvrBackground : styles.nonDvrBackground,
        )}
      />
      {renderMetadata && (
        <div className={styles.metadata}>{renderMetadata(hasFocus)}</div>
      )}
      {isNowPlaying && (
        <div
          className={classNames(styles.nowPlaying)}
          data-testid="now-playing-badge"
        >
          <img
            alt="equalizer"
            src={equalizerImage}
            className={
              isHighlights ? styles.equalizerForHighlights : styles.equalizer
            }
          />
        </div>
      )}
    </div>
  );
};

export default MediaView;
